module.exports = __webpack_public_path__ + "img/sidebar_setting.fd87f6ce.svg";